import { filterRecommendationProducts } from 'lib/utils/recommendation-eligibility'
import { ADDITIONAL_RELATED_SECTIONS } from 'components/pdp/const'
import { hasLocizeTranslation } from 'lib/utils/locize'
import DynamicComponentData from './const'

const getProductArray = (productList) =>
  Array.isArray(productList) ? productList : productList.products

const getIsFetched = (meta) =>
  typeof meta === 'object' ? !meta.isFetching : meta

const getSectionDataFetchingParams = (
  auth,
  maxProductLength,
  productId,
  type,
) => {
  switch (type) {
    case ADDITIONAL_RELATED_SECTIONS[0]:
      return [{ productId, limit: maxProductLength }]
    case ADDITIONAL_RELATED_SECTIONS[1]:
      return [auth, productId]
    default:
      return [productId]
  }
}

const getDynamicComponentData = (
  auth,
  maxProductLength,
  productId,
  t,
  type,
) => {
  const { id, dataFetchingMethod, title } = DynamicComponentData[type]

  const dataFetchingParams = getSectionDataFetchingParams(
    auth,
    maxProductLength,
    productId,
    type,
  )
  const [sectionData, isFetched] = dataFetchingMethod(...dataFetchingParams)

  return {
    id,
    isFetched: getIsFetched(isFetched),
    productList: filterRecommendationProducts(getProductArray(sectionData)),
    translatedTitle: hasLocizeTranslation(t, title.key, title.value),
  }
}

export default getDynamicComponentData
